import React, { Fragment } from 'react';
import {
  getHours,
  getHoursString,
  getDayName,
  getDayNameShort,
} from '../../utils/datetime';

// Components
import Page from '../../components/Page/Page';
import WeatherIcon from '../../components/WeatherIcon/WeatherIcon';
import {
  Wrapper,
  PageTitle,
  ForecastContainer,
  HourlyForecastContainer,
  HourlyForecast,
  HourlyForecastTime,
  HourlyForecastRain,
  HourlyForecastTemp,
  HourlyForecastDayDivider,
  DailyForecastContainer,
  DailyForecast,
  DailyForecastDay,
  DailyForecastTemp,
  DailyForecastIcon,
} from './Weather.styles';

const Weather = ({ title, content }) => {
  const currentWeather = content[0].data.current;
  const hourlyForecast = content[0].data.hourly;
  const dailyForecast = content[0].data.daily;

  return (
    <Page background={false}>
      <Wrapper>
        <PageTitle>{title}</PageTitle>

        <ForecastContainer>
          <HourlyForecastContainer>
            <HourlyForecast>
              <HourlyForecastTime>Jetzt</HourlyForecastTime>
              <HourlyForecastRain></HourlyForecastRain>
              <WeatherIcon type={currentWeather.weather[0].icon} />
              <HourlyForecastTemp>{`${Math.ceil(
                currentWeather.temp
              )} °C`}</HourlyForecastTemp>
            </HourlyForecast>

            {hourlyForecast.map((item, index) => {
              const unix_timestamp = item.dt;
              const date = new Date(unix_timestamp * 1000);

              return (
                <Fragment key={index}>
                  {getHours(date) === 0 && (
                    <HourlyForecastDayDivider>
                      {getDayNameShort(date)}
                    </HourlyForecastDayDivider>
                  )}

                  <HourlyForecast key={unix_timestamp}>
                    <HourlyForecastTime>
                      {getHoursString(date)}
                    </HourlyForecastTime>
                    {item.pop > 0 ? (
                      <HourlyForecastRain>{`${Math.ceil(
                        item.pop * 100
                      )} %`}</HourlyForecastRain>
                    ) : (
                      <HourlyForecastRain></HourlyForecastRain>
                    )}
                    <WeatherIcon type={item.weather[0].icon} />
                    <HourlyForecastTemp>{`${Math.ceil(
                      item.temp
                    )} °C`}</HourlyForecastTemp>
                  </HourlyForecast>
                </Fragment>
              );
            })}
          </HourlyForecastContainer>
          <DailyForecastContainer>
            {dailyForecast.map((item, index) => {
              const unix_timestamp = item.dt;
              const date = new Date(unix_timestamp * 1000);

              return (
                <DailyForecast key={unix_timestamp}>
                  <DailyForecastDay>{getDayName(date)}</DailyForecastDay>
                  <DailyForecastIcon>
                    <WeatherIcon type={item.weather[0].icon} />
                    {item.pop > 0 && (
                      <div>{`${Math.ceil(item.pop * 100)} %`}</div>
                    )}
                  </DailyForecastIcon>
                  <DailyForecastTemp>
                    <span>{`${Math.ceil(item.temp.max)} °C`}</span>
                    <span>{`${Math.ceil(item.temp.min)} °C`}</span>
                  </DailyForecastTemp>
                </DailyForecast>
              );
            })}
          </DailyForecastContainer>
        </ForecastContainer>
      </Wrapper>
    </Page>
  );
};

export default Weather;
